import { MAX_LOADED_MESSAGES, PAGE_SIZE } from 'data-lake/preview/Constants';
import Routes from 'data-lake/Routes';

const stopSearchResultsPolling = (page: number, progress: number) =>
  !window.location.pathname.endsWith(Routes.PREVIEW) || progress >= page * (100 / (MAX_LOADED_MESSAGES / PAGE_SIZE));

export default stopSearchResultsPolling;
